var _rect, _line, _line2, _line3, _line4, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbnailPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 180",
    width: 320,
    height: 180,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f0f4f8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e2e8f0",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#94a3b8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#64748b",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 180,
    fill: "url(#bg)",
    rx: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 60,
    x2: 320,
    y2: 60,
    stroke: "#d1d9e0",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 120,
    x2: 320,
    y2: 120,
    stroke: "#d1d9e0",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 0,
    x2: 106,
    y2: 180,
    stroke: "#d1d9e0",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 213,
    y1: 0,
    x2: 213,
    y2: 180,
    stroke: "#d1d9e0",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128, 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    width: 64,
    height: 44,
    rx: 6,
    fill: "url(#icon)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 14,
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 3,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 8,
    fill: "#94a3b8",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 14,
    height: 8,
    rx: 3,
    fill: "#94a3b8",
    opacity: 0.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 138,
    textAnchor: "middle",
    fontFamily: "'Apple SD Gothic Neo', 'Malgun Gothic', sans-serif",
    fontSize: 12,
    fill: "#94a3b8",
    letterSpacing: 0.5
  }, "\uC774\uBBF8\uC9C0 \uBBF8\uB4F1\uB85D")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailPlaceholder);
export default __webpack_public_path__ + "static/media/thumbnail-placeholder.9b3d5154c472065a0ff65704b0975ccb.svg";
export { ForwardRef as ReactComponent };